import { inventoryService } from "../../services";
import {
  customToast,
  getCountOfTradeTotalItems,
  addSearchKeyToArrayObject,
  handleIsLabelNotificationOnEditInventory,
  createCompanyDynamicUrl,
  handleMapTcgObjectToDbJson,
  generateUuid,
} from "../../shared/utility";
import { custom, failure, success } from "./actionsUtilities";
import {
  systemConstants,
  inventoryConstants,
  storeConstants,
  toastType,
  toastMessages,
  routesPathConstants,
  defaultGridState,
  EMPTY_STRING,
  buttonNameConstants,
} from "../../constants";
import { systemActions } from "./system.action";
import { storeActions } from "./store.action";
import { downloadCSV } from "../../shared/utility";
import { NOTIFICATION_TYPES } from "../../system/globalEnums";

//-------get All inventory of current store
const getAllInventory = (storeId, isInventorySummaryApiCall = true) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_ALL_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getAllInventory(storeId)
      .then(
        (response) => {
          dispatch(
            success(
              addSearchKeyToArrayObject(response, ["sku", "product_name"]),
              inventoryConstants.GET_ALL_INVENTORY
            )
          );
          isInventorySummaryApiCall &&
            dispatch(getStoreInventorySummary(storeId));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_ALL_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateInventory = (
  storeId,
  data,
  isLabelNotification,
  gridState = defaultGridState,
  navigate = false,
  scrollRef = 0,
  isAddShrinkTracking = false
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.UPDATE_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .updateInventory(storeId, data, isAddShrinkTracking)
      .then(
        (response) => {
          if (navigate) {
            navigate(createCompanyDynamicUrl(routesPathConstants.INVENTORY), {
              state: {
                gridState: gridState,
                scrollRef: scrollRef,
              },
            });
          }
          dispatch(getStoreInventorySummary(storeId));
          dispatch(getPaginatedInventory(storeId, gridState));
          if (
            handleIsLabelNotificationOnEditInventory(
              response,
              isLabelNotification
            )
          ) {
            dispatch(
              storeActions.getUserNotifications(
                storeId,
                true,
                inventoryConstants.PRODUCT_UPDATED_SUCCESSFULLY,
                true
              )
            );
          } else {
            customToast(
              inventoryConstants.PRODUCT_UPDATED_SUCCESSFULLY,
              toastType.SUCCESS
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.UPDATE_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updatePriceChangeProduct = (
  storeId,
  data,
  isLabelNotification,
  gridState
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.UPDATE_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .updateInventory(storeId, data)
      .then(
        (response) => {
          dispatch(getPaginatedInventory(storeId, gridState, true));
          if (
            handleIsLabelNotificationOnEditInventory(
              response,
              isLabelNotification
            )
          ) {
            dispatch(
              storeActions.getUserNotifications(
                storeId,
                true,
                inventoryConstants.PRODUCT_UPDATED_SUCCESSFULLY,
                true
              )
            );
          } else {
            customToast(
              inventoryConstants.PRODUCT_UPDATED_SUCCESSFULLY,
              toastType.SUCCESS
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.UPDATE_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const quantityShrink = (data) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.SHRINK_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .quantityShrink(data)
      .then(
        (response) => {
          // customToast(
          //   toastMessages.SHARINK_UPDATED_SUCCESSFULLY,
          //   toastType.SUCCESS
          // );
          dispatch(
            systemActions.pageRedireaction(routesPathConstants.INVENTORY)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.SHRINK_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get All inventory summary of current store
const getStoreInventorySummary = (storeId) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.INVENTORY_HISTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getStoreInventorySummary(storeId)
      .then(
        (response) => {
          dispatch(success(response, inventoryConstants.INVENTORY_HISTORY));
        },
        (error) => {
          dispatch(failure(error, inventoryConstants.INVENTORY_HISTORY));
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.INVENTORY_HISTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Empty inventory Redux
const emptyAllInventory = () => {
  return (dispatch) => {
    dispatch(
      success(
        {
          inventory: [],
          pageSize: 20,
          pageNumber: 1,
          totalPages: 0,
          totalRecords: 0,
          pageEndRecordNumber: 0,
          pageStartRecordNumber: 0,
        },
        inventoryConstants.GET_ALL_INVENTORY
      )
    );
  };
};

//-------delete some or multi product
const deleteInventory = (
  data,
  storeId,
  gridState = defaultGridState,
  isAddShrinkTracking = false
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.DELETE_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .deleteInventory(data, storeId, isAddShrinkTracking)
      .then(
        (response) => {
          customToast(
            toastMessages.ITEM_DELETED_SUCCESSFULLY,
            toastType.SUCCESS
          );
          dispatch(getPaginatedInventory(storeId, gridState));
          dispatch(getStoreInventorySummary(storeId));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.DELETE_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const clearItemHistory = (data) => {
  return (dispatch) => {
    dispatch(success(data, inventoryConstants.GET_INVENTORY_HISTORY));
  };
};

const getInventoryHistory = (storeId, type, start, end, cat) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_INVENTORY_HISTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getInventoryHistory(storeId, type, start, end, cat)
      .then(
        (response) => {
          dispatch(success(response, inventoryConstants.GET_INVENTORY_HISTORY));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_INVENTORY_HISTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get All inventory of current store
const getPricechartingProductById = (productMetaData, productId) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_PRICECHARTING_PRODUCT_BY_ID,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getPricechartingProductById(productId)
      .then(
        (response) => {
          dispatch(
            success(
              {
                productMetaData: productMetaData,
                productObject: response,
              },
              inventoryConstants.GET_PRICECHARTING_PRODUCT_BY_ID
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(
            failure([], inventoryConstants.GET_PRICECHARTING_PRODUCT_BY_ID)
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_PRICECHARTING_PRODUCT_BY_ID,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get All inventory of current store
const getTcgPlayerProductById = (edittedProductObj, productId) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_TCG_PLAYER_PRODUCT_BY_ID,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getTcgPlayerProductById(productId)
      .then(
        (response) => {
          let mappedRes = handleMapTcgObjectToDbJson(
            response,
            edittedProductObj
          );
          dispatch(
            custom(
              {
                productMetaData: mappedRes,
                productObject: mappedRes.productObject,
              },
              inventoryConstants.SET_THIRD_PARTY_API_PRODUCT_INFO
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(
            failure([], inventoryConstants.GET_TCG_PLAYER_PRODUCT_BY_ID)
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_TCG_PLAYER_PRODUCT_BY_ID,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get pokemon card product by id
const getScryFallProductById = (productMetaData, productId) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_SCRYFALL_PRODUCT_BY_ID,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getscryfallApiProductById(productId)
      .then(
        (response) => {
          dispatch(
            success(
              {
                productMetaData: productMetaData,
                productObject: response,
              },
              inventoryConstants.GET_PRICECHARTING_PRODUCT_BY_ID
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(
            failure([], inventoryConstants.GET_PRICECHARTING_PRODUCT_BY_ID)
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_SCRYFALL_PRODUCT_BY_ID,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get All inventory of current store
const getInventoryByPricechartingId = (storeId, data) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getInventoryByPricechartingId(storeId, data)
      .then(
        (response) => {
          dispatch(
            success(
              response,
              inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(
            failure(
              [],
              inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID
            )
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

// process submision if no consolidation, and shows modal if consolidation
const getInventoryByProductMetaDataAndConsolidation = (
  storeId,
  productMetaData,
  handleYesButtonClick,
  handleNoButtonClick
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getInventoryByProductMetaData(storeId, productMetaData)
      .then(
        (response) => {
          // consolidation case
          if (response) {
            dispatch(
              success(
                { isConsolidationModal: true, handleYesButtonClick },
                inventoryConstants.SET_CONSOLIDATION_MODAL
              )
            );
          }

          // no consolidation, proceed with form submission
          else {
            handleYesButtonClick?.isProductEdit &&
            handleYesButtonClick?.isEditCustomItemModal
              ? handleYesButtonClick.functionToCall(
                  handleYesButtonClick.functionAttributes
                )
              : handleYesButtonClick.functionToCall(
                  ...handleYesButtonClick.functionAttributes
                );
            if (handleYesButtonClick.toggleCustomItemModal) {
              handleYesButtonClick.toggleCustomItemModal();
            }
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(
            failure(
              [],
              inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID
            )
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

// all these set the same state: getInventoryByPricechartingId, getInventoryByProductMetaDataAndConsolidation, getStoreCustomItemsForInventoryProductsReducer.
const getInventoryByCustomItemCheck = (storeId) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_INVENTORY_PRODUCT_BY_CUSTOM_ITEM_CHECK,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getStoreCustomProducts(storeId)
      .then(
        (response) => {
          dispatch(
            success(
              response.length ? response : [],
              inventoryConstants.GET_INVENTORY_PRODUCT_BY_CUSTOM_ITEM_CHECK
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(
            failure(
              [],
              inventoryConstants.GET_INVENTORY_PRODUCT_BY_CUSTOM_ITEM_CHECK
            )
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_INVENTORY_PRODUCT_BY_CUSTOM_ITEM_CHECK,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get All inventory of current store
const getTags = (storeId) => {
  return (dispatch) => {
    dispatch(
      custom(inventoryConstants.GET_TAGS, systemConstants.SPINNER_ACTIVATE)
    );
    inventoryService
      .getTags(storeId)
      .then(
        (response) => {
          dispatch(success(response, inventoryConstants.GET_TAGS));
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(failure([], inventoryConstants.GET_TAGS));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_TAGS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const emptyPriceChartingProductObject = () => {
  return (dispatch) => {
    dispatch(custom(EMPTY_STRING, inventoryConstants.EMPTY_THE_OBJECT));
  };
};

const setPriceChartingProductInfo = (data) => {
  return (dispatch) => {
    dispatch(custom(data, inventoryConstants.SET_THIRD_PARTY_API_PRODUCT_INFO));
  };
};

const emptyInventoryProductsList = () => {
  return (dispatch) => {
    dispatch(
      custom(EMPTY_STRING, inventoryConstants.EMPTY_INVENTORY_PRODUCTS_LIST)
    );
  };
};

//-------get All inventory of current store
const addInventory = (data, handleHideModal) => {
  return (dispatch) => {
    dispatch(
      custom(inventoryConstants.ADD_INVENTORY, systemConstants.SPINNER_ACTIVATE)
    );
    inventoryService
      .addBatchInventory([data])
      .then(
        (response) => {
          handleHideModal();
          dispatch(toggleAddModal(false));
          dispatch(getPaginatedInventory(data?.store?.id, defaultGridState));
          dispatch(getStoreInventorySummary(data?.store?.id));
          dispatch(emptyPriceChartingProductObject());
          dispatch(
            storeActions.getUserNotifications(
              data.store.id,
              true,
              `${data.price.quantity} items added successfully.`
            )
          );

          dispatch(getTags(data.store.id));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.ADD_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------handle transfer company inventory
const handleTransferCompanyInventory = (
  data,
  handleHideModal,
  isEditInventory = false,
  stateData = {}
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.TRANSFER_INVNETORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .handleTransferCompanyInventory(data)
      .then(
        (response) => {
          handleHideModal();
          customToast(toastMessages.TRANSFERED_SUCCESSFULLY, toastType.SUCCESS);
          dispatch(
            getPaginatedInventory(data?.from?.store?.id, defaultGridState)
          );
          dispatch(getStoreInventorySummary(data?.from?.store?.id));
          if (isEditInventory) {
            stateData?.navigate(
              createCompanyDynamicUrl(routesPathConstants.INVENTORY_EDIT),
              {
                state: {
                  data: {
                    ...stateData?.data,
                    price: {
                      ...stateData?.data?.price,
                      quantity:
                        Number(stateData?.data?.price?.quantity) -
                        Number(data?.from?.inventory[0]?.price.quantity),
                    },
                  },
                },
              }
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.TRANSFER_INVNETORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Page Redireaction
const toggleAddModal = (value) => {
  return (dispatch) => {
    dispatch(custom(value, inventoryConstants.TOGGLE_ADD_MODAL));
  };
};

//-------Page Redireaction
const setPokemonProductInReducer = (productMetaData, value) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.SET_POKEMON_OBJECT,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    dispatch(
      custom(
        {
          productMetaData: productMetaData,
          productObject: value,
        },
        inventoryConstants.SET_POKEMON_OBJECT
      )
    );
    dispatch(
      custom(
        inventoryConstants.SET_POKEMON_OBJECT,
        systemConstants.SPINNER_DEACTIVATE
      )
    );
  };
};

//-------Add batch inventory
const addBatchInventory = (
  data,
  handleCloseModal,
  handleClearFilter,
  fulfillInvoice = { isfulfillInvoice: false }
) => {
  return (dispatch) => {
    const jobId = generateUuid();
    dispatch(
      custom(inventoryConstants.ADD_INVENTORY, systemConstants.SPINNER_ACTIVATE)
    );
    dispatch(
      custom(
        {
          isVisible: true,
          message: inventoryConstants.ADDING_INVENTORY,
          jobId,
        },
        inventoryConstants.IS_INVENTORY_IMPORTING
      )
    );
    inventoryService
      .addBatchInventory(data, jobId)
      .then(
        (response) => {
          // fulfill the invoice
          if (fulfillInvoice.isfulfillInvoice) {
            dispatch(
              fulfillInvoice.fulfillInvoiceCallback(
                fulfillInvoice.invoice,
                response.updatedInventory,
                fulfillInvoice.gridState
              )
            );
          }

          handleClearFilter();
          handleCloseModal(true);
          dispatch(getPaginatedInventory(data[0].store.id, defaultGridState));
          dispatch(getStoreInventorySummary(data[0].store.id));
          dispatch(
            storeActions.getUserNotifications(
              data[0].store.id,
              true,
              `${getCountOfTradeTotalItems(
                data || 0,
                "quantity"
              )} items added successfully.`
            )
          );

          dispatch(getTags(data[0].store.id));
        },
        (error) => {
          dispatch(
            custom(
              { isVisible: false, message: "", jobId: null },
              inventoryConstants.IS_INVENTORY_IMPORTING
            )
          );
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.ADD_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const addBatchInventoryDraft = (data) => {
  return (dispatch) => {
    dispatch(
      custom(inventoryConstants.ADD_INVENTORY, systemConstants.SPINNER_ACTIVATE)
    );
    inventoryService
      .addBatchInventoryDraft(data)
      .then(
        (response) => {
          customToast(
            toastMessages.DRAFT_SAVED_SUCCESSFULLY,
            toastType.SUCCESS
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(success([], inventoryConstants.SET_ADD_BATCH_INVENTORY));
        dispatch(success(false, inventoryConstants.SET_IS_BATCH_INVENTORY));
        dispatch(
          custom(
            inventoryConstants.ADD_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

// //-------Add batch inventory
// const importFileInventory = (
//   data,
//   toastMessage,
//   hideModalCallback = undefined,
//   frontEndValidateRes = undefined
// ) => {
//   return (dispatch) => {
//     inventoryService
//       .importFileInventory(data)
//       .then(
//         (response) => {
//           // structure the response of invnetory import and creating CSV containing invalid products (front end invalid inventory + backend invalid inventory)
//           handleImportInventoryResponse(
//             data,
//             dispatch,
//             response,
//             toastMessage,
//             hideModalCallback,
//             frontEndValidateRes
//           );
//         },
//         (error) => {
//           customToast(error, toastType.ERROR);
//         }
//       )
//       .finally(() => {
//         dispatch(custom(false, inventoryConstants.IS_INVENTORY_IMPORTING));
//       });
//   };
// };

//-------Add batch inventory
const addCustomItem = (data, toastMessage, handleHideModal) => {
  return (dispatch) => {
    dispatch(
      custom(inventoryConstants.ADD_INVENTORY, systemConstants.SPINNER_ACTIVATE)
    );
    inventoryService
      .addBatchInventory(data)
      .then(
        (response) => {
          handleHideModal();
          dispatch(getPaginatedInventory(data[0].store.id, defaultGridState));
          dispatch(getStoreInventorySummary(data[0].store.id));
          dispatch(
            storeActions.getUserNotifications(
              data[0].store.id,
              true,
              `${getCountOfTradeTotalItems(
                data || 0,
                "quantity"
              )} items added successfully.`
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.ADD_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get price change threshold
const getPriceChangeThreshold = (storeId) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_PRICE_CHANGE_THRESHOLD,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getPriceChangeThreshold(storeId)
      .then(
        (response) => {
          dispatch(
            success(response, inventoryConstants.GET_PRICE_CHANGE_THRESHOLD)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_PRICE_CHANGE_THRESHOLD,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get price change threshold
const addPriceChangeThreshold = (data, handleHideModal) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.ADD_PRICE_CHANGE_THRESHOLD,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .addPriceChangeThreshold(data)
      .then(
        (response) => {
          dispatch(
            getPaginatedInventory(data.store.id, defaultGridState, true)
          );
          dispatch(getPriceChangeThreshold(data.store.id));
          customToast(
            toastMessages.THRESHOLD_UPDATED_SUCCESSFULLY,
            toastType.SUCCESS
          );
          handleHideModal();
          dispatch(getPriceChanges(data.store.id));
          // inventoryService.handleThresholdCsvData(data.store.id).then(() => {
          //   dispatch(getPriceChanges(data.store.id));
          // });
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.ADD_PRICE_CHANGE_THRESHOLD,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get Data for price changes grid
const getPriceChanges = (storeId) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_PRICE_CHANGE_DATA,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getPriceChanges(storeId)
      .then(
        (response) => {
          dispatch(success(response, inventoryConstants.GET_PRICE_CHANGE_DATA));
        },
        (error) => {
          dispatch(success([], inventoryConstants.GET_PRICE_CHANGE_DATA));
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_PRICE_CHANGE_DATA,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------dismiss price changes product
const dismissProduct = (storeId, data) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_PRICE_CHANGE_DATA,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .dismissProduct(storeId, data)
      .then(
        (response) => {
          customToast(
            toastMessages.PRODUCT_DISMISSED_SUCCESSFULLY,
            toastType.SUCCESS
          );
          dispatch(getPriceChanges(storeId));
        },
        (error) => {
          dispatch(success([], inventoryConstants.GET_PRICE_CHANGE_DATA));
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_PRICE_CHANGE_DATA,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updatePriceChangeProductPrices = (
  storeId,
  gridState,
  data,
  handleHideModal
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.UPDATE_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .updatePriceChangeProductPrices(storeId, data.changeProductPrice)
      .then(
        (response) => {
          handleHideModal();
          dispatch(getPaginatedInventory(storeId, gridState, true));

          dispatch(
            storeActions.getUserNotifications(
              storeId,
              true,
              toastMessages.PRODUCT_PRICES_UPDATED,
              true
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.UPDATE_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateProductTypes = (storeId, data, handleHideModal) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.UPDATE_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .updatePriceChangeProductPrices(storeId, data)
      .then(
        (response) => {
          dispatch(getPaginatedInventory(storeId, defaultGridState));
          dispatch(getStoreInventorySummary(storeId));
          handleHideModal();
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.UPDATE_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//------get instock products if found
const getInventoryProducts = (storeId, data) => {
  return inventoryService.getInventoryByPricechartingId(storeId, data).then(
    (response) => {
      return response;
    },
    (error) => {
      customToast(error, toastType.ERROR);
    }
  );
};

//------get instock custom products if found
const getStoreCustomProducts = (storeId, data) => {
  return inventoryService.getInventoryByProductMetaData(storeId, data).then(
    (response) => {
      if (response) {
        return [response];
      } else {
        return [];
      }
    },
    (error) => {
      customToast(error, toastType.ERROR);
    }
  );
};

//-------get custom products if exist in current inventory
const getCustomProductsIfExistInInventory = (
  storeId,
  data,
  isEmpty = false
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID,
        systemConstants.SPINNER_ACTIVATE
      )
    );

    if (isEmpty) {
      failure([], inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID);
    } else {
      inventoryService
        .getInventoryByProductMetaData(storeId, data)
        .then(
          (response) => {
            if (response) {
              dispatch(
                success(
                  [response],
                  inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID
                )
              );
            } else {
              dispatch(
                success(
                  [],
                  inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID
                )
              );
            }
          },
          (error) => {
            customToast(error, toastType.ERROR);
            dispatch(
              failure(
                [],
                inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID
              )
            );
          }
        )
        .finally(() => {
          dispatch(
            custom(
              inventoryConstants.GET_INVENTORY_PRODUCT_BY_PRICECHARTING_ID,
              systemConstants.SPINNER_DEACTIVATE
            )
          );
        });
    }
  };
};

//-------activate inventory spinner
const activateImportInventorySpinner = (data) => {
  return (dispatch) => {
    dispatch(custom(data, inventoryConstants.IS_INVENTORY_IMPORTING));
  };
};

//-------get All inventory of current store
const getPaginatedInventory = (
  storeId,
  gridState,
  isPriceChangesApiCall = false
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_ALL_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getPaginatedInventory(storeId, gridState, isPriceChangesApiCall)
      .then(
        (response) => {
          dispatch(success(response, inventoryConstants.GET_ALL_INVENTORY));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_ALL_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getPaginatedInventoryHistory = (storeId, gridState) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_INVENTORY_HISTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getPaginatedInventoryHistory(storeId, gridState)
      .then(
        (response) => {
          dispatch(success(response, inventoryConstants.GET_INVENTORY_HISTORY));
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(failure(null, inventoryConstants.GET_INVENTORY_HISTORY));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_INVENTORY_HISTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get company Inventory
const getCompanyInventory = (companyId, gridState, setIsSearchLoading) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_COMPANY_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getCompanyInventory(companyId, gridState)
      .then(
        (response) => {
          dispatch(success(response, inventoryConstants.GET_COMPANY_INVENTORY));
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(failure({}, inventoryConstants.GET_COMPANY_INVENTORY));
        }
      )
      .finally(() => {
        setIsSearchLoading(false);
        dispatch(
          custom(
            inventoryConstants.GET_COMPANY_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//------- Empty Company Search Inventory
const emptyCompanyInventory = () => {
  return (dispatch) => {
    dispatch(failure({}, inventoryConstants.GET_COMPANY_INVENTORY));
  };
};

//------- set Shopify Product Mapping
const setProductShopifySettings = (data) => {
  return (dispatch) => {
    dispatch(success(data, inventoryConstants.SET_PRODUCT_SHOPIFY_MAPPING));
  };
};

const startNewAuditSession = (storeId, data, navigate = false) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.START_NEW_AUDIT_SESSION,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .startNewAuditSession(storeId, data)
      .then(
        (response) => {
          if (navigate) {
            navigate(
              createCompanyDynamicUrl(
                routesPathConstants.INVENTORY_ITEMS_STOCK_AUDIT_SESSION
              ),
              {
                state: {
                  currentAudit: response,
                },
              }
            );
          }
          dispatch(
            success(response, inventoryConstants.START_NEW_AUDIT_SESSION)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.START_NEW_AUDIT_SESSION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateAuditSession = (storeId, data, status, navigate) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.UPDATE_AUDIT_SESSION,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .updateAuditSession(storeId, data)
      .then(
        (response) => {
          if (navigate) {
            if (status === buttonNameConstants.COMPLETED) {
              dispatch(
                success(
                  response.store,
                  storeConstants.UPDATE_AUDIT_SESSION_COMPLETE
                )
              );
              navigate(
                createCompanyDynamicUrl(
                  routesPathConstants.INVENTORY_ITEMS_STOCK_AUDIT_BREAKDOWN
                ),
                {
                  state: {
                    currentAudit: response.auditSession,
                  },
                }
              );
            } else {
              navigate(
                createCompanyDynamicUrl(
                  routesPathConstants.INVENTORY_ITEMS_STOCK_AUDIT
                ),
                {
                  state: {
                    currentAudit: response.auditSession,
                  },
                }
              );
            }
          } else {
            customToast(toastMessages.CHANGES_SAVED, toastType.SUCCESS);
          }
          dispatch(success(response, inventoryConstants.UPDATE_AUDIT_SESSION));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.UPDATE_AUDIT_SESSION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getPaginatedStockAudit = (storeId, gridState, timeFrame) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_STOCK_AUDIT,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getPaginatedStockAudit(storeId, gridState, timeFrame)
      .then(
        (response) => {
          dispatch(success(response, inventoryConstants.GET_STOCK_AUDIT));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_STOCK_AUDIT,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getStockAuditCategories = (storeId, auditId) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_STOCK_AUDIT_CATEGORIES,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getStockAuditCategories(storeId, auditId)
      .then(
        (response) => {
          dispatch(
            success(response, inventoryConstants.GET_STOCK_AUDIT_CATEGORIES)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_STOCK_AUDIT_CATEGORIES,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getStockAuditBreakdown = (
  storeId,
  auditId,
  breakdownBy,
  gridState,
  filterIds
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_STOCK_AUDIT_BREAKDOWN,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getStockAuditBreakdown(
        storeId,
        auditId,
        breakdownBy,
        gridState,
        filterIds
      )
      .then(
        (response) => {
          dispatch(
            success(response, inventoryConstants.GET_STOCK_AUDIT_BREAKDOWN)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(
            custom(
              inventoryConstants.GET_STOCK_AUDIT_BREAKDOWN,
              systemConstants.SPINNER_DEACTIVATE
            )
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_STOCK_AUDIT_BREAKDOWN,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateStockAuditBreakdown = (storeId, auditId, data) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_STOCK_AUDIT_BREAKDOWN,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    return inventoryService
      .updateStockAuditBreakdown(storeId, auditId, data)
      .then(
        (response) => {
          customToast(toastMessages.CHANGES_SAVED, toastType.SUCCESS);
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_STOCK_AUDIT_BREAKDOWN,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateStockAuditCategory = (
  storeId,
  auditId,
  data,
  operation,
  navigate,
  state,
  updateNotes = false
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.UPDATE_AUDIT_CATEGORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    return inventoryService
      .updateStockAuditCategory(storeId, auditId, data, operation)
      .then(
        (response) => {
          if (operation === inventoryConstants.LOCK && navigate && state) {
            navigate(
              createCompanyDynamicUrl(
                routesPathConstants.INVENTORY_ITEMS_STOCK_AUDIT_CATEGORY
              ),
              {
                state: { categoryState: state, categoryRow: response },
              }
            );
          }
          if (updateNotes) {
            customToast(toastMessages.CHANGES_SAVED, toastType.SUCCESS);
          }

          dispatch(success(response, inventoryConstants.UPDATE_AUDIT_CATEGORY));

          // Refresh categories after bulk complete or bulk in-progress
          if (
            operation === buttonNameConstants.COMPLETED ||
            operation === EMPTY_STRING
          ) {
            dispatch(getStockAuditCategories(storeId, auditId));
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.UPDATE_AUDIT_CATEGORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getAuditInventory = (
  storeId,
  auditId,
  categoryName,
  productTypeName,
  gridState,
  isScanned = false
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.GET_AUDIT_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .getAuditInventory(
        storeId,
        auditId,
        categoryName,
        productTypeName,
        gridState,
        isScanned
      )
      .then(
        (response) => {
          dispatch(success(response, inventoryConstants.GET_AUDIT_INVENTORY));
        },
        (error) => {
          dispatch(failure([], inventoryConstants.GET_AUDIT_INVENTORY));
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.GET_AUDIT_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateAuditInventory = (
  storeId,
  auditId,
  categoryName,
  productTypeName,
  data,
  navigate,
  currentAudit,
  operation = "",
  setLocalCategoryRow = false
) => {
  return (dispatch) => {
    dispatch(
      custom(
        inventoryConstants.UPDATE_AUDIT_INVENTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    inventoryService
      .updateAuditInventory(
        storeId,
        auditId,
        categoryName,
        productTypeName,
        data,
        operation
      )
      .then(
        (response) => {
          if (navigate) {
            navigate(routesPathConstants.INVENTORY_ITEMS_STOCK_AUDIT_SESSION, {
              state: { currentAudit: currentAudit },
            });
          }
          if (setLocalCategoryRow) {
            setLocalCategoryRow(response.stockAuditCategory);
          }
          dispatch(
            success(response, inventoryConstants.UPDATE_AUDIT_INVENTORY)
          );
          if (operation === buttonNameConstants.COMPLETED) {
            customToast(
              toastMessages.INVENTORY_UPDATED_AND_CATEGORY_COMPLETED,
              toastType.SUCCESS
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            inventoryConstants.UPDATE_AUDIT_INVENTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Export Authentication Actions
export const inventoryActions = {
  getTags,
  addInventory,
  addCustomItem,
  toggleAddModal,
  quantityShrink,
  dismissProduct,
  getAllInventory,
  deleteInventory,
  updateInventory,
  getPriceChanges,
  clearItemHistory,
  emptyAllInventory,
  addBatchInventory,
  updateProductTypes,
  getCompanyInventory,
  getInventoryHistory,
  getInventoryProducts,
  getPaginatedInventory,
  emptyCompanyInventory,
  getPaginatedStockAudit,
  getStockAuditCategories,
  getStockAuditBreakdown,
  updateStockAuditCategory,
  getAuditInventory,
  updateAuditInventory,
  updateAuditSession,
  startNewAuditSession,
  getStoreCustomProducts,
  addBatchInventoryDraft,
  getScryFallProductById,
  getPriceChangeThreshold,
  addPriceChangeThreshold,
  getTcgPlayerProductById,
  getStoreInventorySummary,
  updatePriceChangeProduct,
  emptyInventoryProductsList,
  setPokemonProductInReducer,
  getPricechartingProductById,
  setPriceChartingProductInfo,
  getPaginatedInventoryHistory,
  getInventoryByCustomItemCheck,
  getInventoryByPricechartingId,
  handleTransferCompanyInventory,
  updatePriceChangeProductPrices,
  activateImportInventorySpinner,
  emptyPriceChartingProductObject,
  getCustomProductsIfExistInInventory,
  setProductShopifySettings,
  getInventoryByProductMetaDataAndConsolidation,
  updateStockAuditBreakdown,
};
